module.exports = __webpack_public_path__ + "img/sharks-2.0b070af1.jpg";